import throttle from './throttle';



var button = document.querySelector('.BackToTopButton');

if (button) {
	window.addEventListener('scroll', throttle(function() {
		button.style.display = window.pageYOffset > 300 ? 'block' : 'none';
	}, 100));

	button.addEventListener('click', function(event) {
		event.preventDefault();
		window.scroll({
			top: 0,
			left: 0,
			behavior: 'smooth'
		});
	});
}
